import {
    CLICK_PLANEJAMENTO_FILTER_BUTTON,
    ADD_FILTER_OPTIONS,
    SET_CAPACIDADE_OPTIONS,
    SET_OCUPACAO_CAPACIDADE,
    CLICK_CAPACIDADE_FILTER_CHECKBOX,
    SHOW_LOADING,
    HIDE_LOADING,
    ADD_CAPACIDADE_FABRICA,
    DEL_CAPACIDADE_FABRICA,
    CLEAN_CAPACIDADE_FABRICA,
    SET_CAPACIDADE_RECURSOS_CRITICOS,
    SET_OCUPACAO_CAPACIDADE_RECURSOS_CRITICOS,
    CLICK_RECURSO_CRITICO_FILTER_CHECKBOX,
    SET_SELECT_CAPACIDADE_ORCADA,
    SHOW_SUCCESS,
    SHOW_WARNING,
    SHOW_ERROR,
    SHOW_PROGRESS_LOADING,
    HIDE_PROGRESS_LOADING,
    SET_CURRENT_DATA_PV,
    SET_FILTROS_COLUNAS_PLANEJAMENTO,
    SET_VERSAO_SELECIONADA,
    SET_MODO_PRODUCAO,
    SET_MODO_REPOSICAO,
    SET_INTERVALO_GERAL,
    SET_INTERVALO_FILTRO,
    DEL_INTERVALO_FILTRO,
} from './actionTypes';

export const setModoProducao = () => ({
    type: SET_MODO_PRODUCAO,
});

export const setIntervaloGeral = (payload) => ({
    type: SET_INTERVALO_GERAL,
    payload,
});

export const setIntervaloFiltro = (payload) => ({
    type: SET_INTERVALO_FILTRO,
    payload,
});

export const deleteIntervaloFiltro = (payload) => ({
    type: DEL_INTERVALO_FILTRO,
    payload,
});

export const setModoReposicao = () => ({
    type: SET_MODO_REPOSICAO,
});

export const setVersaoSelecionada = (versao) => ({
    type: SET_VERSAO_SELECIONADA,
    versao,
});

// import { SET_DATE_FILTER_SELECTED } from './relatorioRecursosCriticosActionTypes';
export const showSuccess = (payload) => ({
    type: SHOW_SUCCESS,
    payload,
});

export const setFiltrosColunas = (payload) => ({
    type: SET_FILTROS_COLUNAS_PLANEJAMENTO,
    payload,
});

export const showWarning = (payload) => ({
    type: SHOW_WARNING,
    payload,
});

export const showError = (payload) => ({
    type: SHOW_ERROR,
    payload,
});

export const showLoading = () => ({
    type: SHOW_LOADING,
});

export const hideLoading = () => ({
    type: HIDE_LOADING,
});

export const setSelectCapacidadeOrcada = (selectCapacidadeOrcada) => ({
    type: SET_SELECT_CAPACIDADE_ORCADA,
    selectCapacidadeOrcada,
});

export const setCapacidadeRecursosCriticos = (capacidadeRecursosCriticos) => ({
    type: SET_CAPACIDADE_RECURSOS_CRITICOS,
    capacidadeRecursosCriticos,
});

export const setCapacidadeOptions = (capacidadeOptions) => ({
    type: SET_CAPACIDADE_OPTIONS,
    capacidadeOptions,
});

export const setOcupacaoCapacidadeRecursosCriticos = (ocupacaoCapacidadeRecursosCriticos) => ({
    type: SET_OCUPACAO_CAPACIDADE_RECURSOS_CRITICOS,
    ocupacaoCapacidadeRecursosCriticos,
});

export const setOcupacaoCapacidadeNos = (ocupacaoCapacidadeNos) => ({
    type: SET_OCUPACAO_CAPACIDADE,
    ocupacaoCapacidadeNos,
});

export const addFilter = (filtros) => ({
    type: ADD_FILTER_OPTIONS,
    filtros,
});

export const addFabricaCapacidade = (fabrica) => ({
    type: ADD_CAPACIDADE_FABRICA,
    fabrica,
});

export const delFabricaCapacidade = (fabrica) => ({
    type: DEL_CAPACIDADE_FABRICA,
    fabrica,
});

export const cleanFabricaCapacidade = () => ({
    type: CLEAN_CAPACIDADE_FABRICA,
});

export const clickCapacidadeFilterCheckbox = ({ capacidadeFilterSelected, isAdd }) => ({
    type: CLICK_CAPACIDADE_FILTER_CHECKBOX,
    capacidadeFilterSelected,
    isAdd,
});

export const clickRecursoCriticoFilterCheckbox = ({ recursoCriticoFilterSelected, isAdd }) => ({
    type: CLICK_RECURSO_CRITICO_FILTER_CHECKBOX,
    recursoCriticoFilterSelected,
    isAdd,
});

export const clickPlanejamentoFilterButton = ({
    valueMaterial,
    valueNotMaterial,
    valueEstoquePermanencia,
    valueMarca,
    valueFabrica,
    valueFabricaVersao,
    valueLinhaProduto,
    valueCategoriaProduto,
    valueColecao,
    valueTipoProdutoAcabado,
    valueDestinoConfeccao,
    valueQtdProgramadaManual,
    valueNo,
    valueNotNo,
    valueFabricaPreparacao,
    valueFabricaVersaoPreparacao,
    valueObservacao,
    valueNivelRisco,
    valuePercAnt,
    valueEstoqueSeguranca,
    valueNecessidadeCalculada,
    valueSaldoNegativo,
    valueTotalMinutos,
    valueQtdPrevisaoTotal,
    valueQtdProgramada,
    valueCoberturaEstoque,
    valueSaldoPositivo,
    valueSaldoCobertura,
    valueLoteMinimo,
    valueEstoqueInicial,
    valueQtdEstoqueProdPed,
    valuePercEstoqueSeg,
    valueQtdVenda,
    valueQtdPrevisao,
    valueRA,
    valueGuardar,
    valueGuardarCalculado,
    valueNecessidadeMultiplo,
    valueEstoqueFinal,
    valueEstoqueFinalFechamento,
    valueQtdAlocada,
    valueVendaDescoberta,
    valueSaldoDescasado,
    valueNaoPrograma,
    valueAplicouMI,
    valueFaixaOperacional,
    valueNotFaixaOperacional,
    valueLicenca,
    valueCliente,
    valueClienteEspecial,
    valueGrupoDeProduto,
    valueJustificativa,
    valueCtZcos,
    valueNotObservacao,
    valueNotCtZcos,
}) => ({
    type: CLICK_PLANEJAMENTO_FILTER_BUTTON,
    valueMaterial,
    valueNotMaterial,
    valueNotObservacao,
    valueNotCtZcos,
    valueEstoquePermanencia,
    valueMarca,
    valueFabrica,
    valueFabricaVersao,
    valueLinhaProduto,
    valueCategoriaProduto,
    valueColecao,
    valueTipoProdutoAcabado,
    valueDestinoConfeccao,
    valueQtdProgramadaManual,
    valueNo,
    valueNotNo,
    valueFabricaPreparacao,
    valueFabricaVersaoPreparacao,
    valueObservacao,
    valueNivelRisco,
    valuePercAnt,
    valueEstoqueSeguranca,
    valueNecessidadeCalculada,
    valueSaldoNegativo,
    valueTotalMinutos,
    valueQtdPrevisaoTotal,
    valueQtdProgramada,
    valueCoberturaEstoque,
    valueSaldoPositivo,
    valueSaldoCobertura,
    valueLoteMinimo,
    valueEstoqueInicial,
    valueQtdEstoqueProdPed,
    valuePercEstoqueSeg,
    valueQtdVenda,
    valueQtdPrevisao,
    valueRA,
    valueGuardar,
    valueGuardarCalculado,
    valueNecessidadeMultiplo,
    valueEstoqueFinal,
    valueEstoqueFinalFechamento,
    valueQtdAlocada,
    valueVendaDescoberta,
    valueSaldoDescasado,
    valueNaoPrograma,
    valueAplicouMI,
    valueFaixaOperacional,
    valueNotFaixaOperacional,
    valueLicenca,
    valueCliente,
    valueClienteEspecial,
    valueGrupoDeProduto,
    valueJustificativa,
    valueCtZcos,
});

export const showProgressLoading = (config) => ({
    type: SHOW_PROGRESS_LOADING,
    config: config,
});

export const hideProgressLoading = () => ({
    type: HIDE_PROGRESS_LOADING,
});

export const setCurrentDataPV = (data) => ({
    type: SET_CURRENT_DATA_PV,
    data,
});
